/* eslint-disable
    camelcase,
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import React from 'react';
import createReactClass from 'create-react-class';
import * as util from 'biojs/Util';
import NoteConstants from 'notebook/notes/NoteConstants';
import PreviewMixin from 'notebook/notes/previews/PreviewMixin';

const PrimerPairPreview = createReactClass({
  mixins: [PreviewMixin],

  statics: {
    getName(item) {
      return `${item.primer_fwd.name} / ${item.primer_rev.name}`;
    },
  },

  getProductLength() {
    const {primer_fwd, primer_rev, sequence_circular, sequence_length} = this.props.item;
    let length = util.productLength(
      [primer_fwd.start, primer_fwd.end],
      [primer_rev.start, primer_rev.end],
      sequence_circular,
      sequence_length
    );
    length += primer_fwd.overhang_length + primer_rev.overhang_length;
    return length;
  },

  getMeltingTemperature(primer) {
    const bindingBases = primer.bases.slice(primer.overhang_length);
    // Note: nucleotide type is not exposed for the primers, may need to change data if we support RNA primer pairs
    return util.meltingTemperature(bindingBases, util.NucleotideType.DNA);
  },

  noteType: NoteConstants.PRIMER_PAIR,
  className: 'note-primer-pair',

  renderMeltingTemperature(tm) {
    return `${tm.toFixed(1)} \u00B0C`;
  },

  renderName() {
    return 'Primer Pair';
  },

  renderItem() {
    const {primer_fwd, primer_rev} = this.props.item;
    const forwardTm = this.getMeltingTemperature(primer_fwd);
    const reverseTm = this.getMeltingTemperature(primer_rev);
    return (
      <dl className="dl-horizontal">
        <dt>Forward Primer</dt>
        <dd>{`${primer_fwd.name}, ${this.renderMeltingTemperature(forwardTm)}`}</dd>
        <dt>Reverse Primer</dt>
        <dd>{`${primer_rev.name}, ${this.renderMeltingTemperature(reverseTm)}`}</dd>
        <dt>Product Size</dt>
        <dd>{util.formatBaseCount(this.getProductLength())}</dd>
        <dt>
          T<sub>m</sub>
          {' Difference'}
        </dt>
        <dd>{this.renderMeltingTemperature(reverseTm - forwardTm)}</dd>
      </dl>
    );
  },
});

export default PrimerPairPreview;
